import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export function ProtectedRoute({ roles, redirect = '/', children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to={redirect} state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    // Redirect based on user role
    const target =
      user.role === 'SUPER_ADMIN'
        ? '/admin'
        : user.role === 'WAREHOUSE_ADMIN'
        ? '/warehouse'
        : '/';
    return <Navigate to={target} replace />;
  }
  return children;
}
